import { render, staticRenderFns } from "./TextHighlighter.vue?vue&type=template&id=709efc31&scoped=true&"
import script from "./TextHighlighter.vue?vue&type=script&lang=js&"
export * from "./TextHighlighter.vue?vue&type=script&lang=js&"
import style0 from "./TextHighlighter.vue?vue&type=style&index=0&id=709efc31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709efc31",
  null
  
)

export default component.exports